import _limitNumber from "./limitNumber";
import _multipleOf from "./multipleOf";
import _limitLength from "./limitLength";
import _pattern from "./pattern";
import _limitProperties from "./limitProperties";
import _required from "./required";
import _limitItems from "./limitItems";
import _uniqueItems from "./uniqueItems";
import _const from "./const";
import _enum from "./enum";
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const limitNumber_1 = _limitNumber;
const multipleOf_1 = _multipleOf;
const limitLength_1 = _limitLength;
const pattern_1 = _pattern;
const limitProperties_1 = _limitProperties;
const required_1 = _required;
const limitItems_1 = _limitItems;
const uniqueItems_1 = _uniqueItems;
const const_1 = _const;
const enum_1 = _enum;
const validation = [
// number
limitNumber_1.default, multipleOf_1.default,
// string
limitLength_1.default, pattern_1.default,
// object
limitProperties_1.default, required_1.default,
// array
limitItems_1.default, uniqueItems_1.default,
// any
{
  keyword: "type",
  schemaType: ["string", "array"]
}, {
  keyword: "nullable",
  schemaType: "boolean"
}, const_1.default, enum_1.default];
exports.default = validation;
//# sourceMappingURL=index.js.map
export default exports;